import React from 'react'
import Autocomplete from '../Autocomplete'
import { useNavigate } from 'react-router-dom'
import { SearchEntity } from 'types/SearchEntity'
import { getUrlForType } from '../../utils/getUrlForEntity'

export const GlobalSearch = () => {
    const navigate = useNavigate()

    const handleChange = (option: SearchEntity | null) => {
        if (option === null) return

        const url = getUrlForType(option)

        if (url) {
            navigate(url, { replace: true })
        }
    }

    return <Autocomplete onChange={handleChange} placeholder={'Sök bolag, emissioner, TO, investerare...'} />
}
